<div class="nsc-form-add-file">
  <div>
    <button
      mat-raised-button
      id="addfile_button"
      type="button"
      class="nsc-form-actions__button "
      color="primary"
      [disabled]="uploadedFiles.length >= maxFileCount"
      (click)="fileInputClick()">
      Add File
      <mat-icon aria-hidden="true">add_circle_outline</mat-icon>
    </button>
  </div>
  <input
    ng2FileSelect
    id="input-files"
    type="file"
    (change)="onChange($event)"
    [disabled]="uploadedFiles.length >= maxFileCount"
    [accept]="'.' + allowedFileTypes.join(', .')"
    [uploader]="uploader"
    aria-label="Add file"
    />

  <div class="nsc-form-add-file__help">
    <button mat-icon-button aria-label="Information about file requirements" (click)="openDialog()">
      <mat-icon aria-hidden="true">info</mat-icon>
    </button>
  </div>
  <span role="status" class="cdk-visually-hidden">{{ removeStatus }}</span>
  <span role="status" class="cdk-visually-hidden">{{ uploadStatus }}</span>
</div>
@if (uploadedFiles.length > 0) {
  <div class="col-12 col-lg-10 uploaded-files-container">
    <table mat-table #table [dataSource]="dataSource" class="uploaded-files-table">
      <caption class="cdk-visually-hidden">Uploaded files</caption>
      <ng-container matColumnDef="itemName">
        <th mat-header-cell *matHeaderCellDef scope="col">File</th>
        <td mat-cell *matCellDef="let uploadedFile">
          {{ uploadedFile.originalFileItem.file.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="itemStatus">
        <th mat-header-cell *matHeaderCellDef scope="col">Status</th>
        <td mat-cell *matCellDef="let uploadedFile">
          @if (!uploadedFile.originalFileItem.isSuccess && !uploadedFile.originalFileItem.isError && !uploadedFile.originalFileItem.isCancel && !uploadedFile.originalFileItem.isUploading) {
            <span>Pending</span>
          }
          @if (uploadedFile.originalFileItem.isSuccess && (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status !== 'fail')) {
            <span>Uploaded</span>
          }
          @if ((uploadedFile.originalFileItem.isError || (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'fail')) && !uploadedFile.originalFileItem.isUploading) {
            <span class="mat-error">Error</span>
          }
          @if (uploadedFile.originalFileItem.isCancel) {
            <span>Cancelled</span>
          }
          @if (uploadedFile.originalFileItem.isUploading) {
            <span>Uploading&hellip;</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="itemSize">
        <th mat-header-cell *matHeaderCellDef scope="col">Size</th>
        <td mat-cell *matCellDef="let uploadedFile">
          {{ roundFileSizeValue(uploadedFile.originalFileItem.file.size) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="itemButtons">
        <th mat-header-cell *matHeaderCellDef scope="col">Remove</th>
        <td mat-cell *matCellDef="let uploadedFile">
          @if ((uploadedFile.originalFileItem.isError || uploadedFile.originalFileItem.isCancel || (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'fail')) && !uploadedFile.originalFileItem.isUploading) {
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="'Retry uploading ' + uploadedFile.originalFileItem.file.name"
              (click)="retryFileClick(uploadedFile)">
              <mat-icon aria-hidden="true">replay</mat-icon>
            </button>
          }
          <button
            mat-icon-button
            type="button"
            class="cancel-button"
            [attr.aria-label]="'Remove ' + uploadedFile.originalFileItem.file.name"
            (click)="removeFileClick(uploadedFile)">
            <mat-icon aria-hidden="true">cancel</mat-icon>
          </button>
        </td>
      </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"  ></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"  ></tr>
    </table>
    <nsc-spacer size="sm"></nsc-spacer>
    @if (uploader.isUploading) {
      <div>
        <nsc-spacer size="md"></nsc-spacer>
        <div class="mat-body-2" id="upload_progress_label">Upload progress:</div>
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            aria-labelledby="upload_progress_label"
            aria-valuemin="0"
            aria-valuemax="100"
            [attr.aria-valuenow]="uploader.progress"
            [attr.aria-valuetext]="uploader.progress + ' percent'"
            [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
        </div>
      </div>
    }
  </div>
}
